export default {"src":"/coding-school/_next/static/media/admin.7e734653.svg","height":16,"width":14,"blurWidth":0,"blurHeight":0};